import { motion } from 'framer-motion';
import React from 'react';
import { ReactComponent as AdobeLogo } from '../../Icons/adobeIllustrator.svg';
import { ReactComponent as CSSLogo } from '../../Icons/css3.svg';
import { ReactComponent as ExpressJSLogo } from '../../Icons/expressJS.svg';
import { ReactComponent as FirebaseLogo } from '../../Icons/firebase.svg';
import { ReactComponent as HTMLLogo } from '../../Icons/html5.svg';
import { ReactComponent as JavaScriptLogo } from '../../Icons/javascript.svg';
import { ReactComponent as MaterialUILogo } from '../../Icons/materialUi.svg';
import { ReactComponent as MongoDBLogo } from '../../Icons/mongoDB.svg';
import { ReactComponent as NodeJSLogo } from '../../Icons/nodeJS.svg';
import { ReactComponent as NPMLogo } from '../../Icons/npm.svg';
import { ReactComponent as PostmanLogo } from '../../Icons/postman.svg';
import { ReactComponent as ReactLogo } from '../../Icons/react.svg';
import { ReactComponent as ReduxLogo } from '../../Icons/redux.svg';
import '../../Styles/About/AboutPage.css';

const AboutPageLogos = () => {
    return (
        <React.Fragment>
            <div className="logos-main-wrapper-container flex-box">
                <motion.h1 initial={{ x: `-800%` }} animate={{ x: 0 }} transition={{ duration: 1 }}>Languages</motion.h1>
                <div className="flex-box logos-box">
                    <motion.div className="flex-box logo-name" initial={{ y: `900%` }} animate={{ y: 0 }} transition={{ duration: 0.6, delay: 0.4 }}>
                        <HTMLLogo />
                        <span>HTML5</span>
                    </motion.div>
                    <motion.div className="flex-box logo-name" initial={{ y: `900%` }} animate={{ y: 0 }} transition={{ duration: 0.6, delay: 0.5 }}>
                        <CSSLogo />
                        <span>CSS3</span>
                    </motion.div>
                    <motion.div className="logo-name flex-box" initial={{ y: `900%` }} animate={{ y: 0 }} transition={{ duration: 0.6, delay: 0.6 }}>
                        <JavaScriptLogo />
                        <span>JavaScript</span>
                    </motion.div>
                </div>
            </div>
            <div className="logos-main-wrapper-container flex-box">
                <motion.h1 initial={{ x: `-800%` }} animate={{ x: 0 }} transition={{ duration: 1, delay: 0.7 }}>Front End</motion.h1>
                <div className="flex-box logos-box">
                    <motion.div className="logo-name flex-box" initial={{ y: `900%` }} animate={{ y: 0 }} transition={{ duration: 0.6, delay: 1.1 }}>
                        <ReactLogo />
                        <span>React</span>
                    </motion.div>
                    <motion.div className="logo-name flex-box" initial={{ y: `900%` }} animate={{ y: 0 }} transition={{ duration: 0.6, delay: 1.2 }}>
                        <ReduxLogo />
                        <span>Redux</span>
                    </motion.div>
                    <motion.div className="logo-name flex-box" initial={{ y: `900%` }} animate={{ y: 0 }} transition={{ duration: 0.6, delay: 1.3 }}>
                        <NPMLogo />
                        <span>NPM</span>
                    </motion.div>
                    <motion.div className="logo-name flex-box" initial={{ y: `900%` }} animate={{ y: 0 }} transition={{ duration: 0.6, delay: 1.4 }}>
                        <MaterialUILogo />
                        <span>Material-UI</span>
                    </motion.div>
                    <motion.div className="logo-name flex-box" initial={{ y: `900%` }} animate={{ y: 0 }} transition={{ duration: 0.6, delay: 1.5 }}>
                        <AdobeLogo />
                        <span>Adobe Illustrator</span>
                    </motion.div>
                    <motion.div className="logo-name flex-box" initial={{ y: `900%` }} animate={{ y: 0 }} transition={{ duration: 0.6, delay: 1.6 }}>
                        <PostmanLogo />
                        <span>Postman</span>
                    </motion.div>
                </div>
            </div>
            <div className="logos-main-wrapper-container flex-box">
                <motion.h1 initial={{ x: `-800%` }} animate={{ x: 0 }} transition={{ duration: 1, delay: 1.8 }}>Back End</motion.h1>
                <div className="flex-box logos-box">
                    <motion.div className="logo-name flex-box" initial={{ y: `900%` }} animate={{ y: 0 }} transition={{ duration: 0.6, delay: 2 }}>
                        <ExpressJSLogo />
                        <span>Express.js</span>
                    </motion.div>
                    <motion.div className="logo-name flex-box" initial={{ y: `900%` }} animate={{ y: 0 }} transition={{ duration: 0.6, delay: 2.1 }}>
                        <NodeJSLogo />
                        <span>Node.js</span>
                    </motion.div>
                    <motion.div className="logo-name flex-box" initial={{ y: `900%` }} animate={{ y: 0 }} transition={{ duration: 0.6, delay: 2.2 }}>
                        <MongoDBLogo />
                        <span>MongoDB</span>
                    </motion.div>
                    <motion.div className="logo-name flex-box" initial={{ y: `900%` }} animate={{ y: 0 }} transition={{ duration: 0.6, delay: 2.3 }}>
                        <img src={process.env.PUBLIC_URL + '/Images/mongooseJS.png'} alt="Mongoose" />
                        <span>Mongoose</span>
                    </motion.div>
                    <motion.div className="logo-name flex-box" initial={{ y: `900%` }} animate={{ y: 0 }} transition={{ duration: 0.6, delay: 2.4 }}>
                        <FirebaseLogo />
                        <span>Firebase</span>
                    </motion.div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default AboutPageLogos
